export default "/images/aa93145f86c6782b479985fd191e3d5a.png";